export const api = {
  authentication: {
    register: 'register',
    login: 'login',
    fetchUser: 'users/:userId',
  },
  projects: {
    all: 'projects',
    byLocations: 'projects/?coordinates=:locations',
    singleProject: 'projects/:projectId',
    archiveProject: 'projects/:projectId/archive',
    unArchiveProject: 'projects/:projectId/unarchive',
    likeProject: 'projects/:projectId/favorite',
    unLikeProject: 'projects/:projectId/unfavorite',
    saveSearchProject: 'project-search',
    saveComment: 'project/:projectId/comments',
    getComment: 'project/:projectId/comments',
    deleteComment: 'project/:projectId/comments/:commentId',
    editComment: 'project/:projectId/comments/:commentId',
    saveStatus: 'user-projects-status',
  },
  callLogs: {
    saveCallLog: 'project/:projectId/call-logs',
    allCallLogs: 'project/:projectId/call-logs',
  },
  contact: {
    getEmailTemplate: 'email-templates/:templateId',
    sendEmailToContactAPI: 'project/:projectId/emails',
    getEmailLogs: 'project/:projectId/emails',
    getContactRoles: 'project/:projectId/contact-roles',
  },
  replies: {
    saveReply: 'comments/:commentId/replies',
    editReply: 'comments/:commentId/replies/:replyId',
    deleteReply: 'comments/:commentId/replies/:replyId',
  },
  notification: {
    getNotifications: 'project-notifications',
  },
  hotScopes: {
    getHotScopes: 'hotscopes',
  },
  regions: {
    getRegions: 'regions',
  },
};
